module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Compliance with 18 U.S.C. 2257"},"ja":{"browser_title":"Compliance with 18 U.S.C. 2257"}}')
  delete Component.options._Ctor
}
